import { computed, Ref } from 'vue';
export default class SocialIncentiveButtons {
	public googleTemplate = computed(() => this.template.value === 'Big'? 'Large': this.template.value);
	constructor(public direction: Ref<string>, public template: Ref<string>) {
	}
}

